import theme_icons from "../../icons.js";

const { __ } = wp.i18n;
const { registerBlockType, } = wp.blocks;
const { RichText, InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, ToggleControl, RangeControl } = wp.components;
const { useEffect } = wp.element;

const jobboard = {
    title: 'Greenheart Job Board',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    //attributes
    attributes: {

        per_page: {
            type: 'number',
            default: 8
        },
        format: {
            type: 'string',
            default: 'index'
        },
        showImages: {
            type: 'boolean',
            default: true
        },
        showRegion: {
            type: 'number',

        },
        showCountry: {
            type: 'number',

        },
        showType: {
            type: 'number',
        },
        showCategory: {
            type: 'number',
        },
        showDuration: {
            type: 'number',
        },
    },

    edit({ attributes, setAttributes }) {
        const { per_page, format, showImages, showCountry, showRegion, showCategory, showDuration, showType } = attributes;
        // const forceShowCountry = showCountry ?? 1;
        // const forceShowRegion = showRegion ?? 1;
        useEffect(() => {
            if (showRegion === undefined) {
                setAttributes({ showRegion: 1 });
            }

            if (showCountry === undefined) {
                setAttributes({ showCountry: 1 });
            }
            if (showType === undefined) {
                setAttributes({ showType: 1 });
            }
            if (showCategory === undefined) {
                setAttributes({ showCategory: 1 });
            }
            if (showDuration === undefined) {
                setAttributes({ showDuration: 1 });
            }
        }, []);
        return ([
            <InspectorControls>
                <PanelBody title={__('CAP Positions Settings')}>
                    <p><strong>Show Images?</strong></p>
                    <ToggleControl
                        label={__('Show Images')}
                        checked={showImages}
                        onChange={() => setAttributes({ showImages: !showImages })}
                    />
                    <p><strong>Posts Per Page</strong></p>
                    <RangeControl
                        label="How many Posts to show?"
                        value={per_page}
                        onChange={(value) => setAttributes({ per_page: value })}
                        min={4}
                        max={20}
                        step={1}
                    />


                    <p><strong>Show Type? (in form)</strong></p>
                    <ToggleControl
                        label={__('Show Type')}
                        checked={showType}
                        onChange={() => setAttributes({ showType: showType ? 0 : 1 })}
                    />

                    <p><strong>Show Category? (in form)</strong></p>
                    <ToggleControl
                        label={__('Show Category')}
                        checked={showCategory}
                        onChange={() => setAttributes({ showCategory: showCategory ? 0 : 1 })}
                    />

                    <p><strong>Show Region? (in form)</strong></p>
                    <ToggleControl
                        label={__('Show Region')}
                        checked={showRegion}
                        onChange={() => setAttributes({ showRegion: showRegion ? 0 : 1 })}
                    />

                    <p><strong>Show Country? (in form)</strong></p>
                    <ToggleControl
                        label={__('Show Country')}
                        checked={showCountry}
                        onChange={() => setAttributes({ showCountry: showCountry ? 0 : 1 })}
                    />

                    <p><strong>Show Duration? (in form)</strong></p>
                    <ToggleControl
                        label={__('Show Duration')}
                        checked={showDuration}
                        onChange={() => setAttributes({ showDuration: showDuration ? 0 : 1 })}
                    />
                    {/* This is just here for future builds - currently only index supported */}
                    {/* <SelectControl
                    label={__('Select Format')}
                    value={format}
                    options={[
                        { label: 'Index', value: 'index' },
                        { label: 'Grid', value: 'grid' },
                        { label: 'List', value: 'list' },
                    ]}
                    onChange={(val) => setAttributes({ format: val })}
                /> */}
                </PanelBody>
            </InspectorControls>,
            <div className="rbt-jobboard">
                <h1>Screenshot goes here </h1>
            </div>
        ]);
    },
    save({ attributes }) { return null; }
};

registerBlockType('rbt/jobboard', jobboard);
export default jobboard;